import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header bg-white" }
const _hoisted_3 = { class: "card-title d-flex flex-row justify-content-between" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "d-flex flex-column align-items-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock" }, null, -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "alert alert-info alert-styled-left alert-arrow-left alert-dismissible" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Dieses Ticket wurde erstellt durch ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-3" }, " Ticketverlauf ", -1)
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "list-feed list-feed-rhombus" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "text-prewrap" }
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-3" }, " Auf das Ticket antworten ", -1)
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "col-form-label" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-6\"><button class=\"btn btn-block btn-primary btn-lg mr-3\">Problem behoben</button></div><div class=\"col-6\"><button class=\"btn btn-block btn-secondary btn-lg\">Benötige Hilfe beim beheben</button></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.ticket.name) + " | ", 1),
            _createElementVNode("small", null, "#" + _toDisplayString(_ctx.ticket.id), 1)
          ]),
          _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.ticket.extendName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("small", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.ticket.date), 1)
          ]),
          _createElementVNode("small", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.ticket.time), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("b", null, _toDisplayString(_ctx.ticket.createdByFullName), 1)
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticket.logs, (log, logIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: logIndex,
              class: "list-feed-item d-flex flex-row justify-content-between align-items-start"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("b", null, _toDisplayString(log.createdByFullName), 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(log.text), 1)
              ]),
              _createElementVNode("small", _hoisted_17, _toDisplayString(log.date) + " " + _toDisplayString(log.time), 1)
            ]))
          }), 128))
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.frm.message.name), 1),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            rows: "4",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.message.value) = $event))
          }, null, 512), [
            [_vModelText, _ctx.frm.message.value]
          ])
        ])
      ]),
      _hoisted_22
    ])
  ]))
}